module.exports = __webpack_public_path__ + "ce1ff6663364d6f8bbe26f0d2213ca34.png";